module.exports = __webpack_public_path__ + "img/bp.c9286796.jpg";